import React from 'react';
import _ from 'lodash';
import cx from 'classnames';


export const Error = ({ className, size, ...props }) => (
  <div className={cx("g-error", className, size)} {...props} />
)

export const ErrorList = ({ errors, ...props }) => (
  !_.isEmpty(errors) 
  ? <div className="g-error-list">
      {_.isArray(errors) && <>
        {_.map(errors, (e, i) => <Error key={`${e}-${i}`}>{e}</Error>)}</>}
      {_.isPlainObject(errors) && <>
        {_.map(errors, (v, k) => <Error key={k}>{v}</Error>)}</>}
      {_.isString(errors) &&
        <Error>{errors}</Error>}
    </div>
  : null
)

export const ServerErrors = ({ errors, ...props}) => (
  <ErrorList errors={_.pick(errors, 'server')} {...props} />
)


const ErrorMark = props => {
  return <div className="error-mark" />;
}
export default ErrorMark;